/* ReactionParticleEffect.tsx generated by @compiled/babel-plugin v0.36.1 */
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "./ReactionParticleEffect.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { ResourcedEmoji } from '@atlaskit/emoji';
import { layers } from '@atlaskit/theme/constants';
import { RESOURCED_EMOJI_COMPACT_HEIGHT } from '../shared/constants';
var containerStyle = null;
var reactionParticleStyle = null;
export var PARTICLE_COUNT = 4;
export var ReactionParticleEffect = function ReactionParticleEffect(_ref) {
  var emojiProvider = _ref.emojiProvider,
    emojiId = _ref.emojiId;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswh2mm _1ltvftgi _1pbyifev _m602idpf"])
  }, _toConsumableArray(Array(PARTICLE_COUNT)).map(function (_, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: ax(["_y44v7u0o _kqswstnw _154iidpf _1ltvidpf _lcxvglyw _tzy4idpf _5sagpwmj _1qen1lpd _xg4k6ebc _91vyftgi _1lac188d _jsy51n1a _7vm81dfm"])
    }, /*#__PURE__*/React.createElement(ResourcedEmoji, {
      emojiProvider: emojiProvider,
      emojiId: emojiId,
      fitToHeight: RESOURCED_EMOJI_COMPACT_HEIGHT
    }));
  }));
};